import { createContext } from 'react';
import type { Dispatch } from 'react';
import type { CvssAction, CvssState } from './types';

export const CvssContext = createContext<CvssState | null>(null);
export const CvssContextDispatch = createContext<Dispatch<CvssAction> | null>(
    null,
);
